import { IS_DEV } from "@/utils/env";

/**
 * Dev-only structured console.debug. No-op in production.
 *
 * @param {string} tag - e.g. "[QMA]"
 * @param {string} phase - Short label for the step.
 * @param {Record<string, unknown>} [details] - Serializable context (avoid PII).
 */
export function devDebugLog(tag, phase, details = {}) {
  if (!IS_DEV) return;
  // eslint-disable-next-line no-console -- intentional dev-only diagnostics
  console.debug(tag, phase, details);
}
